<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">{{ name }} ></span>
			<span>开始测试</span>
			<el-button type="primary" style="margin-left: 20px;display: none;" @click="ceshiOption()">选择</el-button>
		</div>
		<section class="gaokao-content">
			<div class="my-title">{{ name }}
				
			</div>
			<article class="testTwo-con" v-if="list.length > 0">
				<div class="testTwo-list" v-for="item in list" :key="item.Id">
					<div v-if="item.Id === 1109" class="sub-title">同学关系测评</div>
					<div v-else-if="item.Id === 1137" class="sub-title">师生关系测评</div>
					<!-- <div
                        v-else-if="item.Id === 165"
                        class="sub-title"
                    >
                        专业测评第一步--兴趣分析
                    </div>
                    <div
                        v-else-if="item.Id === 255"
                        class="sub-title"
                    >
                        专业测评第二步--性格分析
                    </div>
                    <div
                        v-else-if="item.Id === 339"
                        class="sub-title"
                    >
                        专业测评第三步--能力分析
                    </div> -->
					<p class="test-ctxt" :class="{ 'empty-question': !item.notEmpty }" v-if="$route.query.id == '11'">
						{{ item.Sort }}/{{ item.Id >= 1137 ? teacherCount : studentCount }}
						{{ item.Title }}{{ item.Remark }}
					</p>
					<!-- <template v-else-if="$route.query.id == '13'">
                        <p
                            class="test-ctxt"
                            v-if="item.Id < 255"
                        >{{item.Sort}}/{{ interestCount }} {{item.Title}}{{item.Remark}}</p>
                        <p
                            class="test-ctxt"
                            v-else-if="item.Id < 339"
                        >{{item.Sort}}/{{ characterCount }} {{item.Title}}{{item.Remark}}</p>
                        <p
                            class="test-ctxt"
                            v-else
                        >{{item.Sort}}/{{ abilityCount }} {{item.Title}}{{item.Remark}}</p>
                    </template> -->
					<p class="test-ctxt" :class="{ 'empty-question': !item.notEmpty }" v-else>
						{{ item.Sort }}/{{ list.length }} {{ item.Title }}{{ item.Remark }}
					</p>
					<template v-if="item.ImgList.length > 0">
						<div class="way-testB"><img :src="imgUrl" alt="" v-for="imgUrl in item.ImgList" :key="imgUrl" />
						</div>
					</template>
					<template v-if="item.Type === 1">
						<ul class="testTwo-ul">
							<li v-for="answer in item.AnswerList" :key="answer.Id">
								<input type="radio" :name="'q' + item.Id" :value="answer.Option"
									v-model="item.Option" />
								<p>{{ answer.Option }}.{{ answer.Content }}</p>
							</li>
						</ul>
					</template>
					<template v-if="item.Type === 2">
						<ul class="testTwo-ul">
							<li v-for="answer in item.AnswerList" :key="answer.Id">
								<input type="checkbox" :name="'q' + item.Id" :value="answer.Option"
									v-model="item.OptionList" />
								<p>{{ answer.Option }}.{{ answer.Content }}</p>
							</li>
						</ul>
					</template>
				</div>
			</article>
			<div class="test-btn"><button class="gaokao-btn" type="button" @click="submit">提交</button></div>
		</section>
		<!-- 提交弹窗 -->
		<div class="popup" v-show="isSub">
			<div class="pop-width animated fadeIn">
				<div class="submit-bg"><img src="../../../image/pop-del.png" @click="isSub = false" /></div>
				<p class="submit-tit">提交成功</p>
				<p class="submit-txt">系统将自动跳转[我的报告]，跳转后点击[查看报告]</p>
				<p class="submit-txt">马上了解最适合你科目组合吧!</p>
				<button class="gaokao-btn pop-btn" @click="goReport">确定</button>
			</div>
		</div>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				ratioTime:null,
				isJiaIng: false,
				// 弹窗
				isSub: false,
				list: [],
				name: ''
			};
		},
		computed: {
			// 同学关系数量
			studentCount() {
				return this.list.filter(a => a.Category === '同学关系测评').length;
			},
			// 师生关系题数量
			teacherCount() {
				return this.list.filter(a => a.Category === '师生关系测评').length;
			},
			// 兴趣分析
			interestCount() {
				return this.list.filter(a => a.Category === '专业测评第一步--兴趣分析').length;
			},
			// 性格分析
			characterCount() {
				return this.list.filter(a => a.Category === '专业测评第二步--性格分析').length;
			},
			// 能力分析
			abilityCount() {
				return this.list.filter(a => a.Category === '专业测评第三步--能力分析').length;
			}
		},
		created() {
			this.getQuestion();
			this.name = this.$route.query.name;
		},
		beforeDestroy() {
			if (this.ratioTime) {
				clearTimeout(this.ratioTime);
				this.ratioTime = null;
			}
		},
		mounted() {
			this.drawLineB(0);
		},
		methods: {
			drawLineB(nub) {
				var that = this;
				console.log('nub', nub);
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: nub + '%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [{
							value: nub,
							name: ''
						}, {
							value: (100 - nub),
							name: ''
						}]
					}]
				});
				if (nub > 0 && nub < 100) {
					that.ratioTime = setTimeout(() => {
						var dd = nub;
						if (dd === 99) {
							dd = 99;
						} else if (dd > 80) {
							dd = dd + 1;
						} else if (dd > 60) {
							dd = dd + 5;
						} else {
							dd = dd + 10;
						}
						that.drawLineB(dd);
					}, 1000);
				} else {
					if (that.ratioTime) {
						clearTimeout(that.ratioTime);
						that.ratioTime = null;
					}
				}
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			// 返回上一级
			goBack() {
				this.$router.go(-1);
			},
			// 获取题目
			getQuestion() {
				this.$api.getEvaluationQuestion(this.$route.query).then(res => {
					const questionList = res.data.map(a => {
						a.Title = a.Title.replaceAll('##', '');
						a.Content = '';
						a.Option = '';
						a.OptionList = [];
						a.ContentList = [];
						if (a.Type === 3 && a.AnswerCount > 1) {
							for (let i = 0; i < a.AnswerCount; i++) {
								a.ContentList.push('');
							}
						}
						a.notEmpty = true;
						return a;
					});
					this.list = questionList;
				});
			},
			ceshiOption(){
				if(this.list.length>0){
					this.list = this.list.map(a=>{
						a.Option='A'
						return a;
					});
				}
			},
			// 我的报告
			goReport() {
				this.$router.push('/report');
			},
			// 提交答案
			submit() {
				const emptyList = this.list.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				if (emptyList.length > 0) {
					this.list = this.list.map(a => {
						a.notEmpty = !emptyList.some(b => b.Id === a.Id);
						return a;
					});
					this.$util.showError('有未完成的题目，请完成后提交');
					return;
				}
				const model = {
					EvaluationId: Number(this.$route.query.id),
					Key: this.$route.query.key
				};
				model.Question = this.list.map(a => {
					const obj = {
						QuestionId: a.Id,
						Type: a.Type,
						Content: a.Content,
						Option: a.Option
					};
					if (a.Type === 2) {
						obj.Option = a.OptionList.join(',');
					}
					if (a.Type === 3 && a.AnswerCount > 1) {
						a.Content = a.Id === 7 ? `${a.ContentList[0][1]},${a.ContentList[2]}` : a.ContentList.join(
							',');
					}
					return obj;
				});
				// const loading = this.$loading({
				// 	lock: true
				// });
				this.isJiaIng = true;
				this.drawLineB(10);
				this.$api.saveEvaluation(model).then(res => {
					this.isSub = true;
					console.log('获取数据', res);
					this.drawLineB(100);
					setTimeout(() => {
						this.isJiaIng = false;
						setTimeout(() => {
							this.drawLineB(0);
							this.goReport();
							// loading.close();
						}, 300);
					}, 500);
				});
			}
		}
	};
</script>

<style scoped>
	.test-ctxt.empty-question {
		color: #ff1e00;
		font-weight: bold;
	}

	.sub-title {
		font-size: 20px;
		padding: 0 0 20px 20px;
		color: #333;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* testTwo-con */
	.testTwo-con {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin-top: 40px;
	}

	.testTwo-list {
		width: 100%;
		height: auto;
	}

	.test-ctxt {
		font-size: 15px;
		color: #333;
		margin-bottom: 25px;
	}

	.testTwo-ul {
		padding: 0 30px;
		height: auto;
		overflow: hidden;
	}

	.testTwo-ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.testTwo-ul li input {
		margin-right: 15px;
	}

	.testTwo-ul li p {
		font-size: 15px;
		color: #333;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}
</style>
